import ClientChat from '@/models/clientChat';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((clientChatProps: any): ClientChat => {
      return new ClientChat(clientChatProps);
    });
  }
};
